
<script setup>
import CustomQRCode from "./CustomQRCode.vue";
// import CustomBarcode from "./CustomBarcode.vue";
</script>
<style>
@media print {
  @page {
    size: A4 landscape;  /* Set page size to A4 landscape */
    margin: 10mm;        /* Small margins */
  }

  body {
    width: 100%;
    font-size: 20pt;
    color:black;
  }

  #tbl_label table {
    width: 100% !important;  /* full width */
    border-collapse: collapse;
  }

  #tbl_label table th, #tbl_label table td {
    border: 1px solid black !important;
    padding: 8px;
    text-align: left;
  }
}


#tbl_label table {
    width: 100% !important;  /* full width */
    border-collapse: collapse;
    color:black;
    font-size: 20px;
  }

  #tbl_label table th, #tbl_label table td {
    border: 1px solid black !important;
    padding: 8px;
    text-align: left;
  }
</style>
<template>
  <!-- Modal -->
  <div class="modal fade" id="PrintLabelModal" tabindex="-1" aria-labelledby="sewaProfileLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sewaProfileLabel">Batch Label:l {{  model.batchdetails.batchno }}</h5>
          <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">X</button>
        </div>
        <div class="modal-body">
          <div class="row" id="tbl_label">
            <table>
                <tr>
                    <td style="width:30%">{{  model.batchdetails.batchno }}</td>
                    <td colspan="2">
                      <CustomQRCode
                        :value="model.batchdetails.batchno"
                        :size="150"
                        errorCorrectionLevel="Q"
                        dark="#111"
                        light="#fff"
                      />
                    </td>
                    <!-- <td>
                      <CustomBarcode
                        :value="model.batchdetails.batchno"
                        format="CODE128"
                        :width="2"
                        :height="40"
                        lineColor="#111"
                        background="#fff"
                        :displayValue="true"
                      /> -->
                      <!-- <canvas :width="size" :height="size" ref="canvasRef" aria-label="QR Code"></canvas> -->
                    <!-- </td> -->
                </tr>
                <tr>
                    <td>Tarikh Semai</td>
                    <td colspan="2">{{ model.batchdetails.datesemai }}</td>
                </tr>
                <tr>
                    <td>Tarikh Patut Alih</td>
                    <td colspan="2">{{ model.batchdetails.datealih }}</td>
                </tr>
                <tr>
                    <td>Klon</td>
                    <td colspan="2">{{ model.batchdetails.clone }}</td>
                </tr>
                <tr>
                    <td>Remarks</td>
                    <td colspan="2">{{ model.batchdetails.remark }}</td>
                </tr>
                <tr>
                    <td>Jumlah</td>
                    <td colspan="2">{{ model.batchdetails.quantity }}</td>
                </tr>
                </table>
          </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" @click="PrintLabel" data-bs-dismiss="modal">Print</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import axios from 'axios';
export default {
  name:'BatchLabel',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      model:{
        batchdetails:{
            //batchno:this.$route.params.id,
            clone:"1",
            product:'SW',
            block:'',
            datealih: new Date().toISOString().slice(0,10),
            quantity:'',
            remark:'',
            status:'0',
            datesemai:'',
            batchno:''
        }
      },
    }
  },
  watch: {
    id(newId) {   // 👈 directly watch prop "id"
    console.log(newId, "New ID");
      if (newId) {
        this.loadBatchDetails(newId);
      }
    }
  },
  mounted(){
    this.loadBatchDetails(this.id);
  },
  methods: {
    loadBatchDetails(loadID){
        axios.get('nursery/listBatchProfile/' + loadID)
            .then(res => {
                console.log(res.data);
                this.model.batchdetails.block = res.data.batchProfile[0].block;
                this.model.batchdetails.product = res.data.batchProfile[0].product_desc;
                this.model.batchdetails.clone = res.data.batchProfile[0].clone_desc;
                this.model.batchdetails.datealih = res.data.batchProfile[0].datealih;
                this.model.batchdetails.datesemai = res.data.batchProfile[0].datesemai;
                this.model.batchdetails.batchno = res.data.batchProfile[0].batchno;
                this.model.batchdetails.remark = res.data.batchProfile[0].remark;
                this.model.batchdetails.quantity = res.data.batchProfile[0].quantity;
            }).catch(function (error){
                
                console.log('Error',error.message);
            });
    },
    PrintLabel() {
  var content = document.getElementById("tbl_label").innerHTML;

  var printWindow = window.open('', '', 'width=1200,height=800');
  printWindow.document.write('<html><head><title>' + this.model.batchdetails.batchno + '_' + new Date().toISOString().slice(0,10) + '</title>');

  // Add print CSS with landscape
  printWindow.document.write(`
    <style>
      @page { size: A4 landscape; margin: 10mm; }
      body { width: 100%; }
      body, table, td, th, p, span, div {
        font-size: 35pt !important;
      }
      table { width: 95%; border-collapse: collapse; margin: auto 80px auto auto; }
      th, td { border: 1px solid black; padding: 8px; text-align: left; }
    </style>
  `);

  printWindow.document.write("</head><body>");
  printWindow.document.write(content);
  printWindow.document.write("</body></html>");
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.print();
    printWindow.close();
  };
}

    
  },
}
</script>
